import { LEAD_BASED_PAINT } from '@shared/utils/app-static-data';
import { BehaviorSubject } from 'rxjs';
import { IMenu } from './models/core/menu';

export function getBaseMenuItems(): IMenu[] {
  return [
    {
      route: "dashboard",
      name: "Dashboard",
      type: "link",
      icon: "dashboard"
    },
    {
      route: "atp",
      name: "Training Provider",
      type: "sub",
      icon: "school",
      auth: true,
      children: [
        {
          route: "/management",
          name: "Management",
          type: "link",
          
        },
        {
          route: "/applications",
          name: "Applications",
          type: "link",
        }
      ]
    },
    {
      route: "payments",
      name: "Payments",
      type: "link",
      icon: "attach_money",
      auth: true,
    },
    {
      route: "complaints",
      name: "Submit a Complaint",
      type: "link",
      icon: LEAD_BASED_PAINT.complaint.icon,
    },
  ];
}

export const menu$ = new BehaviorSubject<IMenu[]>(getBaseMenuItems());
